//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Query_fun, LookNews_fun, Update_fun, QueryHistory } from '@/api/policymanagement';
import { getChilComList, getProductList, getCompanyList } from '@/api/baseDate';
import { getRoleButtonConfigInfo } from '@/api/permissions';
export default {
  name: "claimApplyquery",
  data: function data() {
    return {
      currentPage4: 4,
      loading: false,
      restaurants: [],
      timeout: null,
      tableData: [],
      options: [{
        value: "666666",
        label: "人民保险"
      }],
      options1: [{
        value: "1",
        label: "上海分公司"
      }],
      options2: [],
      options3: [{
        value: "1",
        label: "是"
      }],
      options4: [{
        value: "0",
        label: "新建"
      }, {
        value: "1",
        label: "待补录"
      }, {
        value: "2",
        label: "暂存"
      }, {
        value: "3",
        label: "自核失败"
      }, {
        value: "4",
        label: "自核通过提交核保"
      }, {
        value: "5",
        label: "核保失败"
      }, {
        value: "6",
        label: "核保成功"
      }, {
        value: "7",
        label: "已申报"
      }],
      inForm: {
        reportNo: "",
        companyCode: "",
        customsListNo: "",
        insuranceCompanyCode: "",
        insuranceCompanyName: "",
        insuredName: "",
        policyNo: "",
        protocolNo: "",
        riskCode: "",
        riskName: "",
        damageDateStart: "",
        damageDateEnd: "",
        reportDateStart: "",
        reportDateEnd: "",
        claimStatus: '',
        confirmStatus: '',
        claimCode: '',
        createByName: this.$store.state.user.userinfo.userId
      },
      pageNo: 1,
      //第几页
      pageSize: 10,
      //每页数量
      total: 0,
      //总条数
      reparationConfirmFlag: true,
      menuList: [],
      rules: {
        insuranceCompanyCode: [{
          required: true,
          message: '请选择保险公司',
          trigger: 'change'
        }],
        companyCode: [{
          required: false,
          message: '请选择分支机构',
          trigger: 'change'
        }],
        riskCode: [{
          required: false,
          message: '请选择产品名称',
          trigger: 'change'
        }],
        addRecordFlag: [{
          required: false,
          message: '请选择自动申报补录',
          trigger: 'change'
        }],
        proposalStatus: [{
          required: false,
          message: '请选择保单状态',
          trigger: 'change'
        }]
      },
      options_insuranceCompanyName: [],
      options_companyName: []
    };
  },
  watch: {
    '$route': 'getSearch'
  },
  mounted: function mounted() {
    var list = this.$store.state.user.userinfo.insuranceCompanyList || [];
    var companyCode = '';

    if (this.$store.state.user.userinfo.insuranceCompanyList.length !== 0) {
      companyCode = this.$store.state.user.userinfo.insuranceCompanyList[0].insuranceCompanyCode || '';
    } // 不同角色用户登录进去保险公司数据源不同
    // 货运险注册用户：register insuranceCompanyList
    // 子账号被保险人用户：subAssured sainsuranceCompanyList
    // 货运险注册用户+子账号被保险人用户 两者合并


    var userRoleType = this.$store.state.user.userinfo.userRoleType;

    if (userRoleType !== null && userRoleType.includes('subAssured')) {
      var saList = this.$store.state.user.userinfo.sainsuranceCompanyList || [];
      var saCompanyCode = this.$store.state.user.userinfo.sainsuranceCompanyList[0].insuranceCompanyCode || '';

      if (userRoleType === 'subAssured') {
        list = saList;
        companyCode = saCompanyCode;
      } else {
        list = list.concat(saList).filter(function (item, index, array) {
          return array.indexOf(item) === index;
        });
      }
    }

    this.get_select(list, companyCode);
    this.restaurants = this.loadAll(); //默认第一个保险公司

    this.inForm.insuranceCompanyCode = this.options_insuranceCompanyName[0].value || '';
    this.inForm.insuranceCompanyName = this.options_insuranceCompanyName[0].label || '';
    this.Init_get();
  },
  created: function created() {
    var _this = this;

    var requestPage = 'claimApplyquery';
    getRoleButtonConfigInfo({
      'requestPage': requestPage
    }).then(function (res) {
      if (res.menuList != null && res.menuList.length > 0) {
        _this.menuList = res.menuList;

        for (var i = 0; i < _this.menuList.length; i++) {
          if (_this.menuList[i].buttonType == 'reparationConfirm') {
            if (_this.menuList[i].startUsing == '1') {
              _this.reparationConfirmFlag = false;
            } else {
              _this.reparationConfirmFlag = true;
            }
          }
        }
      } else {
        _this.reparationConfirmFlag = true;
      }
    });
  },
  filters: {
    claimStatusFilter: function claimStatusFilter(value) {
      console.log(value);

      if (value == '0') {
        return '暂存';
      } else if (value == '1') {
        return '理赔处理中';
      } else if (value == '2') {
        return '理算结果确认中';
      } else if (value == '3') {
        return '理算结果已确认';
      } else if (value == '4') {
        return '理算结果确认中 (线下确认)';
      }
    }
  },
  methods: {
    getSearch: function getSearch() {
      this.search_s('inForm'); // this.Init_get()
    },
    //初始化
    Init_get: function Init_get() {
      var _this2 = this;

      //去除查询条件前后空格
      if (this.inForm.policyNo !== null && this.inForm.policyNo !== undefined && this.inForm.policyNo !== '') {
        this.inForm.policyNo = this.inForm.policyNo.replace(/(^\s*)|(\s*$)/g, "");
      }

      if (this.inForm.claimCode !== null && this.inForm.claimCode !== undefined && this.inForm.claimCode !== '') {
        this.inForm.claimCode = this.inForm.claimCode.replace(/(^\s*)|(\s*$)/g, "");
      }

      if (this.inForm.reportNo !== null && this.inForm.reportNo !== undefined && this.inForm.reportNo !== '') {
        this.inForm.reportNo = this.inForm.reportNo.replace(/(^\s*)|(\s*$)/g, "");
      }

      var data = this.inForm;
      this.loading = true;
      data.pageNo = this.pageNo;
      data.pageSize = this.pageSize;
      QueryHistory(data).then(function (res) {
        var orgCode = JSON.parse(sessionStorage.getItem('neworgCode'));
        console.log(orgCode, "信用代码");

        if (res.content != null) {
          for (var i = 0; i < res.content.length; i++) {
            // 如果查询数据的投保人不是当前登录用户-usertype==0，identifyNumber是投保人的orgcode
            // 场景1，查询的数据是投保数据：使用orgcode - identifyNumber，相同则usertype=1 ，不同则0
            // 场景2，查询的数据是被保险人数据：使用userId - createBy，相同则usertype=1 ，不同则0
            if (res.content[i].queryType != null) {
              var queryType = res.content[i].queryType;

              if (queryType === 'register') {
                if (res.content[i].identifyNumber != null) {
                  if (orgCode !== res.content[i].identifyNumber) {
                    console.log(res.content[i].identifyNumber, i);
                    res.content[i].user_type = '0';
                    _this2.permissionsbtn = false;
                  } else {
                    res.content[i].user_type = '1';
                    _this2.permissionsbtn = true;
                  }
                } else {
                  res.content[i].user_type = '0';
                  _this2.permissionsbtn = false;
                }
              } else if (queryType === 'subAssured') {
                // 查出的数据都是自己为被保险人的数据，无需额外判断
                res.content[i].user_type = '1';
                _this2.permissionsbtn = true;
              } else {
                res.content[i].user_type = '0';
                _this2.permissionsbtn = false;
              }
            } else {
              res.content[i].user_type = '0';
              _this2.permissionsbtn = false;
            }
          }
        }

        console.log(res.content);
        _this2.tableData = res.content;
        _this2.total = res.totalCount;
        _this2.loading = false;
      });
    },
    //保险公司
    insuranceCompanyCode_ch: function insuranceCompanyCode_ch(val) {
      var obj = {};
      obj = this.options_insuranceCompanyName.find(function (item) {
        //这里的userList就是上面遍历的数据源
        return item.value === val; //筛选出匹配数据
      });
      this.inForm.insuranceCompanyName = obj.label; // this.companyqueryAll_fun(val)

      this.riskqueryAll_fun(val);
    },
    //分支机构
    companyCode_ch: function companyCode_ch(val) {
      var obj = {};
      obj = this.options_companyName.find(function (item) {
        //这里的userList就是上面遍历的数据源
        return item.value === val; //筛选出匹配数据
      });
      this.inForm.companyName = obj.label;
    },
    //产品名称 --险种
    riskCode_ch: function riskCode_ch(val) {
      var obj = {};
      obj = this.options2.find(function (item) {
        //这里的userList就是上面遍历的数据源
        return item.value === val; //筛选出匹配数据
      });
      this.inForm.riskName = obj.label;
    },
    //每页条数
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.Init_get();
    },
    //当前页码
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.Init_get();
    },
    //查询
    search_s: function search_s(formName) {
      var _this3 = this;

      this.pageNo = 1;
      this.pageSize = 10; // debugger

      if (this.inForm.damageDateEnd && this.inForm.damageDateStart) {
        if (this.getTimes(this.inForm.damageDateStart) > this.getTimes(this.inForm.damageDateEnd)) {
          this.$message({
            message: '录入出险时间的起期不能晚于出险时间止期',
            type: 'warning'
          });
          return;
        }
      } else if (this.inForm.damageDateEnd && !this.inForm.damageDateStart) {
        this.$message({
          message: '请录入出险时间起期',
          type: 'warning'
        });
        return;
      } else if (!this.inForm.damageDateEnd && this.inForm.damageDateStart) {
        this.$message({
          message: '请录入出险时间止期',
          type: 'warning'
        });
        return;
      }

      if (this.inForm.reportDateEnd && this.inForm.reportDateStart) {
        if (this.getTimes(this.inForm.reportDateStart) > this.getTimes(this.inForm.reportDateEnd)) {
          this.$message({
            message: '录入报案时间的起期不能晚于报案时间止期',
            type: 'warning'
          });
          return;
        }
      } else if (this.inForm.reportDateEnd && !this.inForm.reportDateStart) {
        this.$message({
          message: '请录入报案时间起期',
          type: 'warning'
        });
        return;
      } else if (!this.inForm.reportDateEnd && this.inForm.reportDateStart) {
        this.$message({
          message: '请录入报案时间止期',
          type: 'warning'
        });
        return;
      }

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.Init_get();
        } else {
          return false;
        }
      });
    },
    // 获取时间戳
    getTimes: function getTimes(time) {
      // console.log(this.ruleForm.businessStartDate)
      var date = time;
      date = date.substring(0, 19);
      date = date.replace(/-/g, '/'); //必须把日期'-'转为'/'

      var timestamp = new Date(date).getTime();
      return timestamp;
    },
    //重置
    search_s_clear: function search_s_clear() {
      this.inForm = {
        companyCode: "",
        customsListNo: "",
        insuranceCompanyCode: this.options_insuranceCompanyName[0].value,
        insuranceCompanyName: this.options_insuranceCompanyName[0].label,
        insuredName: "",
        policyNo: "",
        protocolNo: "",
        riskCode: "",
        riskName: "",
        damageDateStart: "",
        damageDateEnd: "",
        reportDateStart: "",
        reportDateEnd: "",
        claimStatus: '',
        claimCode: '',
        createByName: this.$store.state.user.userinfo.userId
      };
      this.insuranceCompanyCode_ch(this.inForm.insuranceCompanyCode);
    },
    //删除
    del_but: function del_but(row) {
      var _this4 = this;

      var data = {
        proposalNo: row.row.proposalNo
      };
      deleteByProposalNo_fun(data).then(function (res) {
        if (res.rtnCode == "0000") {
          _this4.$message({
            message: '删除成功',
            type: 'success'
          });

          _this4.Init_get();
        }
      }); //				this.tableData.splice(row.$index, 1)
    },
    // 支持模糊查询
    loadAll: function loadAll() {
      return [{
        "value": "三全鲜食（北新泾店）",
        "address": "长宁区新渔路144号"
      }, {
        "value": "Hot honey 首尔炸鸡（仙霞路）",
        "address": "上海市长宁区淞虹路661号"
      }, {
        "value": "新旺角茶餐厅",
        "address": "上海市普陀区真北路988号创邑金沙谷6号楼113"
      }];
    },
    querySearchAsync: function querySearchAsync(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        cb(results);
      }, 1000 * Math.random());
    },
    createStateFilter: function createStateFilter(queryString) {
      return function (state) {
        return state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    handleSelect: function handleSelect(item) {},
    view_but2: function view_but2(type, row) {
      var params = {
        type: type,
        insurancecompanyCode: row.row.insuranceCompanyCode,
        protocolNo: row.row.protocolNo,
        riskCode: row.row.riskCode,
        riskName: row.row.riskName,
        proposalNo: row.row.proposalNo
      }; // console.log(params.insurancecompanyCode)

      this.$router.push({
        path: "/policymanagement/insuranceentry/".concat(params.type, "/").concat(params.insurancecompanyCode, "/").concat(params.protocolNo, "/").concat(params.riskCode, "/").concat(params.riskName, "/").concat(params.proposalNo)
      });
    },
    //查看 ------ 编辑
    view_but: function view_but(type, row) {
      // this.$router.push({
      //   name: 'claimentry',
      //   params: {
      //     policyNo: row.row.policyNo,
      //     claimCode: row.row.claimCode,
      //     type: type,
      //     flag: 'apply',
      //     proposalNo: row.row.proposalNo
      //   }
      // });
      var params = {
        policyNo: row.row.policyNo,
        type: type,
        proposalNo: row.row.proposalNo,
        flag: 'apply',
        claimCode: row.row.claimCode
      };
      this.$router.push({
        path: "/claimapplication/claimentry/".concat(params.policyNo, "/").concat(params.type, "/").concat(params.proposalNo, "/").concat(params.flag, "/").concat(params.claimCode)
      }); //				if(row.row.firstLogin == true) {
      //
      //				} else {
      //
      //					this.$message({
      //						message: '该保单号已经进行过理赔！',
      //						type: 'warning'
      //					});
      //
      //				}
    },
    case_query: function case_query() {
      window.open('https://enq.ms-ins.com.cn/msic/index.html');
    },
    reparationConfirm: function reparationConfirm(data) {
      console.log(data);
      this.$router.push({
        path: "/claimapplication/adjustResultNote/".concat(data.claimCode)
      });
    },
    //------下拉信息
    get_select: function get_select(list, code) {
      this.findInsuranceCompany_fun(list);
      this.companyqueryAll_fun(code);
    },
    //保险公司
    findInsuranceCompany_fun: function findInsuranceCompany_fun(list) {
      this.options_insuranceCompanyName = [];

      for (var i = 0; i < list.length; i++) {
        var obj = {};
        obj.value = list[i].insuranceCompanyCode;
        obj.label = list[i].insuranceCompanyName;
        this.options_insuranceCompanyName.push(obj);
      } //				var data = {
      //					insuranceCompanyCode: code
      //				}
      //
      //				getCompanyList(data).then(res => {
      //
      //					this.options_insuranceCompanyName = []
      //					for(var i = 0; i < res.length; i++) {
      //						var obj = {}
      //						obj.value = res[i].insuranceCompanyCode
      //						obj.label = res[i].insuranceCompanyName
      //						this.options_insuranceCompanyName.push(obj)
      //					}
      //
      //				})

    },
    //分支机构
    companyqueryAll_fun: function companyqueryAll_fun(code) {
      var _this5 = this;

      var data = {
        insuranceCompanyCode: code
      };
      getChilComList(data).then(function (res) {
        for (var i = 0; i < res.length; i++) {
          var obj = {};
          obj.value = res[i].companyCode;
          obj.label = res[i].companyName;

          _this5.options_companyName.push(obj);
        }
      });
    },
    //产品名称
    riskqueryAll_fun: function riskqueryAll_fun(code) {
      var _this6 = this;

      var data = {
        insuranceCompanyCode: code
      };
      getProductList(data).then(function (res) {
        _this6.options2 = [];

        for (var i = 0; i < res.length; i++) {
          var obj = {};
          obj.value = res[i].riskCode;
          obj.label = res[i].riskName;

          _this6.options2.push(obj);
        }
      });
    }
  }
};